var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 24.7188C26.0312 25.0312 26.0312 25.5 25.75 25.7812C25.4375 26.0938 24.9688 26.0938 24.6875 25.7812L21 22.0625L17.2812 25.7812C16.9688 26.0938 16.5 26.0938 16.2188 25.7812C15.9062 25.5 15.9062 25.0312 16.2188 24.7188L19.9375 21L16.2188 17.2812C15.9062 16.9688 15.9062 16.5 16.2188 16.2188C16.5 15.9062 16.9688 15.9062 17.25 16.2188L21 19.9688L24.7188 16.25C25 15.9375 25.4688 15.9375 25.75 16.25C26.0625 16.5312 26.0625 17 25.75 17.3125L22.0312 21L25.75 24.7188Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3ee0b16dc6396c7b8c58b3b09c58e13d.svg";
export { ForwardRef as ReactComponent };